import React, { useEffect, useState } from "react";
import './FiltersModalCheckBox.css';

const FiltersModalCheckBox = (props) => {

    const {
        nameSearchVote,
        status,
        type,
        checkboxFilterArrayAdd,
        checkboxFilterArrayRemove,
        isResetAllCheckboxClick,
        changeAllCheckbox,
        statusFilterArray,
        typeFilterArray
    } = props;

    const [value, setValue] = useState('');
    const [isCheckboxChecked, setCheckboxChecked] = useState(false);

    useEffect(() => {
        let isMounted = true;
        if (isResetAllCheckboxClick) {
            isMounted && setCheckboxChecked(false);
            changeAllCheckbox();
        }
        return () => {
            isMounted = false;
        }
    }, [isResetAllCheckboxClick, changeAllCheckbox])

    useEffect(() => {
        let isMounted = true;
        if (status) {
            const findStatus = statusFilterArray?.find((item) => item.statusFilter === status && item.nameFilter === nameSearchVote);
            if (findStatus) {
                isMounted && setCheckboxChecked(true);
            }
            isMounted && setValue(status);
        }
        return () => {
            isMounted = false;
        }
    }, [status])

    useEffect(() => {
        let isMounted = true;
        if (type) {
            const findType = typeFilterArray?.find((item) => item.statusFilter === type && item.nameFilter === nameSearchVote);
            if (findType) {
                isMounted && setCheckboxChecked(true);
            }
            isMounted && setValue(type);
        }
        return () => {
            isMounted = false;
        }
    }, [type])

    function onCheckboxClick(evt) {
        let itemCheck = {
            nameFilter: nameSearchVote,
            statusFilter: evt.target.value
        }
        if (isCheckboxChecked) {
            checkboxFilterArrayRemove(itemCheck);
            setCheckboxChecked(false);
        } else {
            checkboxFilterArrayAdd(itemCheck);
            setCheckboxChecked(true);
        }
    }

    return (
        <label className={'checkbox-status-vote'}>
            <div className={'checkbox-status-vote_container'}>
                <input
                    type="checkbox"
                    value={value}
                    onChange={onCheckboxClick}
                    checked={isCheckboxChecked}
                />
                <span className={'checkbox-status-vote_checkmark'} />
            </div>
            <span>{nameSearchVote}</span>
        </label>
    )
}
export default FiltersModalCheckBox;
